import { ComponentType } from "react"
import { With } from "../common/componentExtensions"

import Store from "./tipiContrattoStore"
import Actions from "./tipiContrattoActions"

export let withTipiContratto = <TProps extends {}>(cmp: ComponentType<TProps>) => With(cmp, Store, () => Actions.getAll());